export const accueils = [
      {
            id: 1,
            img: "/pictures/acceuil/acceuil1.jpg",
      },

      {
            id: 2,
            img: "/pictures/acceuil/acceuil2.jpg",
      },

      {
            id: 3,
            img: "/pictures/acceuil/acceuil3.jpg",
      },

      {
            id: 4,
            img: "/pictures/acceuil/acceuil4.jpg",
      },

      {
            id: 5,
            img: "/pictures/acceuil/rdc_chaumiere3.jpg",
      },

      {
            id: 6,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_1.jpg",
      },
];

export const accueilsTablette = [
      {
            id: 1,
            img: "/pictures/accueil_tablette/accueil_1_jardin.jpg",
      },

      {
            id: 2,
            img: "/pictures/accueil_tablette/accueil_2_jardin.jpg",
      },

      {
            id: 3,
            img: "/pictures/accueil_tablette/accueil_3_jardin.jpg",
      },

      {
            id: 4,
            img: "/pictures/accueil_tablette/accueil_4_jardin.jpg",
      },

      {
            id: 5,
            img: "/pictures/accueil_tablette/accueil_5_chaumiere.jpg",
      },

      {
            id: 6,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_1.jpg",
      }
];
